export enum UserMenuOption {
    Dashboard = 'dashboard',
    Logout = 'logout',
    History = 'history',
}
